/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { ProformaNoteEntryFormColumns } from "../../../data/DynamicTable/Collumns";
import { accountsmanagement } from "../../../config";
import { allProformaFeeNotesQuotationsView } from "../../../data/Axios/queries";
import ProformaNoteEntryForm from "./form";
import ProformaNoteDetailDialog from "./ProformaNoteDetailDialog";

const base_url = accountsmanagement.uri;

function ProformaNoteList() {
  const [openProformaDialog, setOpenProformaDialog] = useState(false);
  const [selectedProforma, setSelectedProforma] = useState(null);
  const [refreshTable, setRefreshTable] = useState(null);

  const actions = {
    entity: "Quotations/Proforma Fee Notes",
    required: "id",
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    ViewProformaLines: {
      key: "VIEWPROFORMALINES",
      button_name: "View Lines",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
      onClick: (row, refresh) => {
        setRefreshTable(() => refresh);
        setSelectedProforma(row);
        setOpenProformaDialog(true);
      },
    },
    PrintProformaNote: {
      key: "PRINTPROFORMANOTE",
      button_name: "Print",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    approveProformaNote: {
      key: "APPROVEPROFORMANOTE",
      button_name: "Convert to Feenote",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: true,
      permission: "ActivatePermission",
      modelName: "id",
      inputObjectName: "activateDeactivateProformaFeeNotesQuotations",
    },
  };

  return (
    <Box m="10px">
      <DynamicTable
        title="Proforma Notes"
        subtitle="View all Proforma Notes, create, edit or view details"
        columns={ProformaNoteEntryFormColumns}
        FormComponent={ProformaNoteEntryForm}
        query={allProformaFeeNotesQuotationsView}
        base_url={base_url}
        actions={actions}
      />

      {openProformaDialog && (
        <ProformaNoteDetailDialog
          open={openProformaDialog}
          onClose={() => {
            setOpenProformaDialog(false);
            if (refreshTable) refreshTable();
          }}
          proformaData={selectedProforma}
          refetchData={() => {
            if (refreshTable) refreshTable();
          }}
        />
      )}
    </Box>
  );
}

export default ProformaNoteList;
